// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  ambushId: __t.u64().primaryKey().name("ambush_id"),
  shipmentId: __t.u64().name("shipment_id"),
  denKey: __t.string().name("den_key"),
  raiders: __t.u32(),
  raidersAlive: __t.u32().name("raiders_alive"),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  startedAt: __t.timestamp().name("started_at"),
  resolveAt: __t.timestamp().name("resolve_at"),
  lastAttritionAt: __t.timestamp().name("last_attrition_at"),
  state: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
